import { render, staticRenderFns } from "./AdminCreateProject.vue?vue&type=template&id=6066aac0&scoped=true&"
import script from "./AdminCreateProject.vue?vue&type=script&lang=js&"
export * from "./AdminCreateProject.vue?vue&type=script&lang=js&"
import style0 from "./AdminCreateProject.vue?vue&type=style&index=0&id=6066aac0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6066aac0",
  null
  
)

export default component.exports